import React from 'react';
import { Moon, Sun, ShoppingCart } from 'lucide-react';
import headerLogo from '../assets/branding/hardware-genie-logo.png';
import './Header.css';

export default function Header({ cartCount, theme, onToggleTheme, onOpenCart }) {
  return (
    <header className="header">
      <div className="header-inner">
        <div className="logo">
          <div className="logo-icon">
            <img src={headerLogo} alt="HardwareGenie logo" className="logo-img" />
          </div>
          <div className="logo-text">
            <span className="logo-main">Hardware<span className="accent">Genie</span></span>
          </div>
        </div>

        <div className="header-right">
          <button className="cart-open-btn" onClick={onOpenCart} aria-label="Open universal cart">
            <ShoppingCart size={14} />
            <span className="mono">Cart {cartCount > 0 ? `(${cartCount})` : ''}</span>
          </button>
          <button
            className="theme-toggle"
            onClick={onToggleTheme}
            aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
            title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          >
            {theme === 'dark' ? <Sun size={14} /> : <Moon size={14} />}
            <span className="mono">{theme === 'dark' ? 'Light' : 'Dark'}</span>
          </button>
          <a href="https://robu.in" target="_blank" rel="noreferrer" className="header-link">Stores</a>
          <a href="#how" className="header-link">How it works</a>
          <a href="#footer-contact" className="header-link">Contact</a>
        </div>
      </div>
    </header>
  );
}
